import type { ReactNode } from 'react';

interface FilterSectionProps {
	label: string;
	children: ReactNode;
}

export const FilterSection = ({ label, children }: FilterSectionProps) => (
	<div className="flex flex-col gap-space-8">
		<span className="text-sm-bold text-neutral-950">{label}</span>
		<div className="flex flex-wrap gap-space-8">{children}</div>
	</div>
);
